import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card flex-fill justify-self-stretch" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "flex-fill d-flex justify-content-center" }
const _hoisted_5 = { class: "form-check form-check-inline" }
const _hoisted_6 = { class: "flex-fill d-flex justify-content-center" }
const _hoisted_7 = { class: "form-check form-check-inline" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "form-floating" }
const _hoisted_10 = { class: "small ms-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_12 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "form-floating" }
const _hoisted_15 = { class: "small ms-2 text-danger" }
const _hoisted_16 = {
  key: 0,
  class: ""
}
const _hoisted_17 = {
  key: 1,
  class: ""
}
const _hoisted_18 = { class: "row mb-2" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "dropdown" }
const _hoisted_21 = {
  type: "button",
  class: "btn btn-outline-secondary btn-sm d-flex justify-content-between",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_22 = { class: "dropdown-menu scrollable-menu" }
const _hoisted_23 = { class: "row mb-2" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "fw-bold" }
const _hoisted_26 = { class: "row mb-2" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = {
  key: 0,
  class: "justify-content-center d-flex text-center",
  style: {"padding-top":"10px"}
}
const _hoisted_31 = { class: "d-flex flex-column" }
const _hoisted_32 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 1,
  class: ""
}
const _hoisted_35 = { class: "input-group d-flex" }
const _hoisted_36 = { class: "input-group-text bg-white fw-bold" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "card-footer justify-content-center d-flex text-center"
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("div", null, [
        _createElementVNode("h5", { class: "mb-0" }, [
          _createElementVNode("i", { class: "fas fa-pen-fancy me-1" }),
          _createTextVNode(" Registrar socio ")
        ])
      ], -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["btn-toolbar", { 'd-none': _ctx.devHelpersHidden }])
      }, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generarUsuario && _ctx.generarUsuario(...args))),
          class: "btn btn-outline-secondary btn-sm"
        }, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("i", { class: "fas fa-hat-wizard" }, null, -1)
        ]))])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'd-none': _ctx.isRegistered })
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["mb-3 d-flex justify-content-center", { 'd-none': !_ctx.innerLegUnlocked }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("input", {
                class: "form-check-input red-gtr",
                type: "radio",
                name: "side-radio-options",
                id: "side-left",
                value: "left",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChange($event))),
                checked: ""
              }, null, 32),
              _cache[16] || (_cache[16] = _createElementVNode("label", {
                class: "form-check-label",
                for: "side-left"
              }, "Izquierda", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("input", {
                class: "form-check-input red-gtr",
                type: "radio",
                name: "side-radio-options",
                id: "side-right",
                value: "right",
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChange($event)))
              }, null, 32),
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                class: "form-check-label",
                for: "side-right"
              }, "Derecha", -1))
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control mb-1", {
                'is-invalid': _ctx.emailValidation.hasError,
                'is-warning': _ctx.emailValidation.hasWarning,
              }]),
              placeholder: "Correo electrónico",
              "aria-label": "Correo electrónico",
              id: "email",
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateEmailInput())),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registrationForm.email) = $event))
            }, null, 34), [
              [
                _vModelText,
                _ctx.registrationForm.email,
                void 0,
                { trim: true }
              ]
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("label", {
              for: "email",
              class: "text-nowrap"
            }, [
              _createElementVNode("i", { class: "far fa-envelope fa-fw me-1" }),
              _createElementVNode("span", { class: "" }, " Correo Electrónico (E-mail) ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.emailValidation.hasWarning)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-exclamation-circle fa-fw me-2" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.emailValidation.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw me-2" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.emailValidation.userMessage), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-warning text-center small mb-1" }, [
            _createElementVNode("i", { class: "fas fa-exclamation-circle fa-fw" }),
            _createTextVNode(" El nombre de usuario no podrá ser modificado. ")
          ], -1)),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control mb-1", { 'is-invalid': !_ctx.usernameAvailable || _ctx.invalidUsername }]),
              placeholder: "Nombre de Usuario",
              "aria-label": "Nombre de Usuario",
              id: "username",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registrationForm.username) = $event)),
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateUsernameInput()))
            }, null, 34), [
              [
                _vModelText,
                _ctx.registrationForm.username,
                void 0,
                { trim: true }
              ]
            ]),
            _cache[21] || (_cache[21] = _createElementVNode("label", {
              for: "username",
              class: "text-nowrap"
            }, [
              _createElementVNode("i", { class: "fas fa-user fa-fw me-1" }),
              _createElementVNode("span", { class: "" }, " Nombre de usuario ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_15, [
            (!_ctx.usernameAvailable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[22] || (_cache[22] = [
                  _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw me-2" }, null, -1),
                  _createTextVNode("El nombre de usuario no está disponible. ", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.invalidUsername)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw me-2" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.usernameValidation.userMessage), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["", { 'd-none': !_ctx.isRegistered }])
      }, [
        _createElementVNode("div", _hoisted_18, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col col-md-4 text-end text-nowrap" }, "Subscripción:", -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", _hoisted_21, [
                _createElementVNode("span", null, _toDisplayString(_ctx.SubscriptionConfig.displayName), 1),
                _cache[25] || (_cache[25] = _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fas fa-caret-down ms-3" })
                ], -1))
              ]),
              _createElementVNode("ul", _hoisted_22, [
                _createElementVNode("li", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setSubscription('gtr-win')))
                }, [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    id: "gtr-win"
                  }, [
                    _createElementVNode("span", { class: "col d-flex flex-row align-items-center fw-lighter ps-0" }, "GTR Win ")
                  ], -1)
                ]))]),
                _createElementVNode("li", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setSubscription('gtr-fly')))
                }, [...(_cache[27] || (_cache[27] = [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    id: "gtr-fly"
                  }, [
                    _createElementVNode("span", { class: "col d-flex flex-row align-items-center fw-lighter ps-0" }, "GTR Fly ")
                  ], -1)
                ]))]),
                _createElementVNode("li", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setSubscription('gtr-go')))
                }, [...(_cache[28] || (_cache[28] = [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    id: "gtr-go"
                  }, [
                    _createElementVNode("span", { class: "col d-flex flex-row align-items-center fw-lighter ps-0" }, "GTR Go ")
                  ], -1)
                ]))])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col col-md-4 text-end text-nowrap" }, "Usuario:", -1)),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.registrationForm.username), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "col col-md-4 text-end text-nowrap" }, "Correo:", -1)),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.registrationForm.email), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          (!_ctx.isOffline)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  (
                  (_ctx.promotions?.tradingAcademy > 0 &&
                    _ctx.promotions?.distributorLicense > 0) ||
                  _ctx.promotions?.both > 0
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("button", {
                          class: "btn btn-outline-secondary",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.registerWithNoVolume && _ctx.registerWithNoVolume(...args))),
                          disabled: _ctx.isOffline || _ctx.isPaying
                        }, " Activar SIN Volumen ", 8, _hoisted_33)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isOffline)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", _hoisted_36, "$ " + _toDisplayString(_ctx.Total) + " " + _toDisplayString(_ctx.SubscriptionConfig.currency), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-primary flex-fill",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#checkout-modal",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.subscriptionQuote())),
                            disabled: _ctx.isOffline || _ctx.isPaying
                          }, " Pagar ", 8, _hoisted_37)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    (!_ctx.isOffline)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'd-none': _ctx.isRegistered })
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.doRegister())),
              disabled: 
            _ctx.isOffline ||
            _ctx.invalidFields() ||
            _ctx.isRegistering ||
            !_ctx.emailOK ||
            !_ctx.usernameOK
          
            }, [
              _cache[32] || (_cache[32] = _createTextVNode(" Registrar ", -1)),
              (_ctx.isRegistering)
                ? (_openBlock(), _createElementBlock("i", _hoisted_40))
                : _createCommentVNode("", true)
            ], 8, _hoisted_39)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass({ 'd-none': !_ctx.isRegistered })
          }, [
            _createElementVNode("button", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToRegister())),
              type: "button",
              class: "btn btn-outline-primary"
            }, " Registrar nuevo socio ")
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}